module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-12.0c71104.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-12.jpg
// module id = Vt/H
// module chunks = 52